import * as React from 'react'

import { SmartImage, Title } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'
import { SchoolPage_school_profile_profileMedia } from '../gql'
import { i18nKeyPrefix } from '../i18n'
import Lightbox from './Lightbox'
import {
  approximateImageSize,
  PhotoContainer,
  PhotosContainer,
  ViewAllContainer,
  ViewAllNativeLink,
} from './Photos.styles'

const PRE = `${i18nKeyPrefix}-PHOTOS`

interface IProps {
  profileMedia: SchoolPage_school_profile_profileMedia[]
}

const displayedCount = 6

export default function Photos(props: IProps) {
  const [lightboxIndex, setLightboxIndex] = React.useState<number | null>(null)

  const { profileMedia } = props

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const orderedProfileMedia = profileMedia.concat().sort((a, b) => a.index - b.index)

  return (
    <div>
      <Title kind="large">{t(`${PRE}-TITLE`)}</Title>

      <PhotosContainer>
        {orderedProfileMedia.slice(0, displayedCount).map((pm, arrayIndex) => (
          <PhotoContainer key={pm.index} onClick={() => setLightboxIndex(arrayIndex)}>
            <SmartImage
              height={approximateImageSize}
              width={approximateImageSize}
              src={pm.media.url}
            />
          </PhotoContainer>
        ))}
      </PhotosContainer>

      <ViewAllContainer>
        <ViewAllNativeLink onClick={() => setLightboxIndex(0)}>
          {t(`${PRE}-LINK`)}
        </ViewAllNativeLink>
      </ViewAllContainer>

      {lightboxIndex !== null && (
        <Lightbox
          index={lightboxIndex}
          profileMedia={orderedProfileMedia}
          onChangeIndex={setLightboxIndex}
          onRequestClose={() => setLightboxIndex(null)}
        />
      )}
    </div>
  )
}
